(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["terraflex-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('terraflex-photo-marquee')) {
    customElements.define('terraflex-photo-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.viewport = this.querySelector('[data-tf-viewport]');
        this.track = this.querySelector('[data-tf-track]');
        this.group = this.querySelector('[data-tf-group]');
        this.button = this.querySelector('[data-tf-motion]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.inView = false;
        if (!this.viewport || !this.track || !this.group || !this.button) return;
        this.originals = Array.from(this.group.children).filter((child) => !child.hasAttribute('data-tf-clone'));
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.sync();
        }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.motion.addEventListener('change', () => this.rebuild(), { signal });
        this.observer = new IntersectionObserver((entries) => {
          this.inView = entries.some((entry) => entry.isIntersecting);
          this.sync();
        }, { rootMargin: '60px' });
        this.observer.observe(this);
        this.resize = new ResizeObserver((entries) => {
          const width = Math.round(entries[0].contentRect.width);
          if (width === this.lastWidth) return;
          this.lastWidth = width;
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.rebuild());
        });
        this.resize.observe(this.viewport);
        this.rebuild();
      }
      cloneNodeForTrack(node) {
        const clone = node.cloneNode(true);
        clone.setAttribute('data-tf-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => element.removeAttribute('data-shopify-editor-block'));
        return clone;
      }
      rebuild() {
        this.removeAttribute('data-enhanced');
        this.track.querySelectorAll('[data-tf-clone]').forEach((element) => element.remove());
        this.button.hidden = true;
        const viewportWidth = this.viewport.clientWidth;
        if (this.motion.matches || !this.originals.length || viewportWidth === 0) {
          this.sync();
          return;
        }
        let repeats = 0;
        while (this.group.getBoundingClientRect().width < viewportWidth && repeats < 32) {
          this.originals.forEach((item) => this.group.append(this.cloneNodeForTrack(item)));
          repeats += 1;
        }
        const secondGroup = this.cloneNodeForTrack(this.group);
        secondGroup.removeAttribute('data-tf-group');
        this.track.append(secondGroup);
        this.viewport.scrollLeft = 0;
        this.setAttribute('data-enhanced', '');
        this.button.hidden = false;
        this.sync();
      }
      sync() {
        const paused = this.userPaused || this.motion.matches || document.hidden || !this.inView;
        this.toggleAttribute('data-paused', paused);
        this.button.setAttribute('aria-pressed', String(this.userPaused));
        this.button.querySelector('[data-tf-motion-label]').textContent = this.userPaused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
        this.removeAttribute('data-enhanced');
        this.track?.querySelectorAll('[data-tf-clone]').forEach((element) => element.remove());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
